import client from './axiosInstance';
import {
  IDeleteRateHistoryEntryData,
  IMemberInfoUpdatingData,
  UpdateRateHistoryEntryData,
} from 'features/memberInfo/memberInfoTypes';

export const fetchOrganizationMemberInfo = async (memberId: number) => {
  return await client.get(`/members/${memberId}`);
};

export const updateMemberInfo = async (data: IMemberInfoUpdatingData) => {
  return await client.patch(`/members/${data.id}`, {
    ...data,
  });
};

export const updatePayRateHistoryEntry = async (data: {
  memberId: number;
  payload: UpdateRateHistoryEntryData;
}) => {
  if (data.payload.paymentRateType === 'billRate') {
    return await client.patch(`/pay-amounts/bill-rate/${data.memberId}`, {
      id: data.payload.id,
      status: data.payload.status,
      rate: data.payload.rate,
      type: data.payload.type,
      startDate: data.payload.startDate,
    });
  } else {
    return await client.patch(`/pay-amounts/pay-rate/${data.memberId}`, {
      id: data.payload.id,
      status: data.payload.status,
      rate: data.payload.rate,
      type: data.payload.type,
      startDate: data.payload.startDate,
    });
  }
};

export const deletePayRateHistoryEntry = async (
  data: IDeleteRateHistoryEntryData
) => {
  return await client.delete(
    `/pay-amounts/${data.payAmountType}/${data.memberId}/${data.entryId}`
  );
};
